import { Space, Layout, Row, Col, Divider, Drawer, Button, theme } from 'antd';
import { Header, Content, Footer } from 'antd/es/layout/layout';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { serviceBundler } from '../../../App';
import style from './TranslationsPage.module.css';
import { useParams } from 'react-router-dom';
import { Language } from '../../../Models/Language/Language';
import { TableTranslations } from '../../../Components/Translation/TableTranslations/TableTranslations';

import { ArrowLeftOutlined } from '@ant-design/icons';
import Search from 'antd/es/input/Search';
import { useTranslation } from 'react-i18next';
import HeaderBar from '../../../Components/Header/HeaderBar';
import FooterBar from '../../../Components/Footer/FooterBar';
import { DbTranslationKeyValue } from '../../../Models/Language/DbTranslationKeyValue';

const { useToken } = theme;

const TranslationsPage = () => {
  const { languageKey } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { token } = useToken();

  const [languageTranslations, setLanguageTranslations] = useState<Language>();

  const childRef = useRef<any>(null);

  useEffect(() => {
    if (languageKey !== undefined) {
      serviceBundler.languageService.GetFetchStatus().subscribe((value) => {
        if (!value) {
          return;
        }
        var translationKeys =
          serviceBundler.languageService.GetLanguage(languageKey);

        if (translationKeys === undefined) {
          navigate('/languages');
        }
        setLanguageTranslations(translationKeys);
        serviceBundler.languageService.SetCurrentLanguage(translationKeys);
      });
    }
  }, [navigate, languageKey]);

  const NavigateToLanguages = () => {
    navigate('/languages');
  };

  const SafeLanguage = (items: Array<DbTranslationKeyValue>) => {
    var newData = languageTranslations;

    newData!.keysLabels = items;
    if (newData != undefined) {
      serviceBundler.languageService.UpdateLanguage(newData);
    }
  };

  const GetTranslations = () => {
    return languageTranslations?.keysLabels;
  };

  const onSearch = (value: string) => {
    const node = childRef.current;
    node!.SetSearchText(value.toLowerCase());
  };

  const onSearchType = (e: any) => {
    const node = childRef.current;
    node!.SetSearchText(e.target.value.toLowerCase());
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
      <Layout>
        <Header className={style.headerStyle}>
          <HeaderBar></HeaderBar>
        </Header>

        <Content
          style={{ backgroundColor: token?.colorPrimaryBg }}
          className={style.headerBlock}
        >
          <Col className={style.middleBlock}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={NavigateToLanguages}
              ></Button>
              <Search
                placeholder={t('inputSearch').toString()}
                allowClear
                onChange={onSearchType}
                onSearch={onSearch}
                style={{ width: 200 }}
              />
            </div>

            <Divider orientation="left">
              {languageTranslations?.languageName}
            </Divider>

            <TableTranslations
              ref={childRef}
              dataSource={GetTranslations()}
              safeData={SafeLanguage}
            ></TableTranslations>

            <Space
              direction="horizontal"
              style={{
                width: '100%',
                marginTop: '20px',
                justifyContent: 'right',
              }}
            ></Space>
          </Col>
        </Content>
        <Footer className={style.footerStyle}>
          <FooterBar></FooterBar>
        </Footer>
      </Layout>
    </Space>
  );
};

export default TranslationsPage;
